import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=580e98d4&scoped=true"
import script from "./StatusSelector.vue?vue&type=script&lang=ts"
export * from "./StatusSelector.vue?vue&type=script&lang=ts"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=580e98d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580e98d4",
  null
  
)

export default component.exports